export * from './SameRangeForSameTile'
